// extracted by mini-css-extract-plugin
export default {"routs":"CustomerInfoRoutes_routs__cxvB4"};